export const SessionStorage = {
    get (key) {
        if (typeof sessionStorage === 'undefined') {
            return;
        }
        const value = sessionStorage.getItem(key);
        if (!value || typeof value === 'undefined') {
            return;
        }
        return JSON.parse(value);
    },
    save (key, value) {
        sessionStorage.setItem(key, JSON.stringify(value));
    },
    remove (key) {
        sessionStorage.removeItem(key);
    }
};
